/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Recommendation Video Component
 *
 * @file ChannelsPracticeCardStyle.js
 * @author Murhsid Ahamedh
 */

import mixins from '../../../assets/styles/mixins.scss';

const PracticeCardClasses = {
  root: {
    height: '100%',
    width: '100%',
    maxHeight: 'var(--card-height)',
    minHeight: 'var(--card-height)',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    border: `1px solid ${mixins.color_elevation_alpha_12}`
  },
  contentWrapper: {
    flex: '1 1 auto',
    minHeight: 0,
    width: '100%',
    minWidth: 0,
    overflowX: 'hidden',
    overflowY: 'hidden',
    boxSizing: 'border-box'
  },
  multipleChoiceContainer: {
    overflowY: 'hidden'
  },
  cardHeadWrapper: {
    backgroundColor: '#EBF9F0',
    height: '48px',
    padding: '8px 16px 8px 16px',
    justifyContent: 'center'
  },
  linkWrapper: {
    textAlign: 'left'
  },
  channelLinkStyles: {
    width: '100%',
    display: 'flex',
    color: '#655591',
    fontSize: '14px',
    justifyContent: 'flex-start'
  },
  cardContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    color: 'rgb(51, 51, 51)',
    fontFamily: 'TT Commons',
    fontWeight: 700,
    fontSize: 16,
    letterSpacing: 0.24
  },
  cardHeadTitleStyles: {
    color: '#000000',
    fontSize: '16px',
    fontWeight: '700',
    letterSpacing: '0.24px',
    fontVariant: 'unset',
    textTransform: 'capitalize'
  }
};

export default PracticeCardClasses;
